import {
    Form,
    FormGroup,
    Input,
    Label,
    Modal
} from "reactstrap"
import { Group, OrderForm, OrderPost } from '../../models/Order'
import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { RootState } from 'setup'
import { postWithoutTokenFunciton } from "utils/ApiHelper"

type Props = {

}
export type MultipleEditModalHandle = {
    showModal: (channel_id: string, priorityOnly: boolean, onCompleted: (data: any) => void) => void;
};


const MultipleEditModal = forwardRef<MultipleEditModalHandle, Props>((props, ref) => {

    const dispatch = useDispatch()
    const groups: Group[] = useSelector<RootState>(({ orders }) => orders.groups, shallowEqual) as Group[] || []
    const [enabled, setEnabled] = useState(1)
    const [note, setNote] = useState("")
    const [show, setVisible] = useState(false);
    const [channel_id, setChannelId] = useState<string>();
    const [priorityOnly, setPriorityOnly] = useState<boolean>(false);


    const [callback, setCallBack] = useState<(data: any) => void>();

    useImperativeHandle(ref, () => ({
        showModal
    }));

    const dismissModal = () => {
        setChannelId('');
        setVisible(false);
    }
    const updateOrder = async () => {
        try {
            const params =note.split(",").map(item=>{
                return {
                    video_id:item
                }
            })

            let res = await postWithoutTokenFunciton(`video/videos?channel_id=${channel_id}`, params);
            callback && callback(res);
            dismissModal();
        } catch (e: any) {
            alert(`Update failed ${e.message}`);
        }


    }

    const showModal = (channel_id: string, priorityOnly: boolean, onCompleted: (data: any) => void) => {
        setPriorityOnly(priorityOnly)
        setChannelId(channel_id);
        setVisible(true);
        setCallBack(() => onCompleted);
    }

    return (
        <Modal isOpen={show}
            modalTransition={{ timeout: 500 }}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Danh sách video chỉ định </h5>
                    {/* <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close">
                        <span className="svg-icon svg-icon-2x"></span>
                    </div> */}
                </div>
                <div className="modal-body">
                    <p>Chỉnh sửa thông tin video cho channel {channel_id}</p>
                    <Form>
                        {
                            <FormGroup>
                                <Label for="exampleEmail" className="required form-label">
                                    Danh sách video cách nhau dấu " , "
                                </Label>
                                <Input
                                    id="list_id"
                                    name="list_id"
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    className="form-control form-control-solid"
                                    type={"textarea"}
                                    placeholder={`video1,video2,video3....`}
                                    style={{ height: "200px" }}
                                />
                            </FormGroup>
                        }
                    </Form>
                </div>
                <div className="modal-footer">
                    <button type="button" onClick={dismissModal} className="btn btn-light" >Thoát</button>
                    <button type="button" onClick={updateOrder} className="btn btn-primary">Lưu thông tin mới</button>
                </div>
            </div>
        </Modal>
    )
});

export default MultipleEditModal